import Vue from 'vue'
import App from './App.vue'
import store from './store'
import 'normalize.css'
import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)
// import VideoPlayer from 'vue-video-player'
// import 'videojs-contrib-hls' // 引入才能播放m3u8文件
// import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'
//
// Vue.use(VideoPlayer)

Vue.config.productionTip = false

store.state.CODE = GetQueryString('code')
store.state.STATE_CODE = GetQueryString('state')

// 开发模式mock数据
if (process.env.NODE_ENV === 'development') {
  store.state.VOD_ADDRESS = 'http://yyk5.gxzyy.com.cn/video/cf3a31bda9c44350806c0c043f6468bc-98313122e8dfbc70cc8500155faed0e9-ld.mp4'
  store.state.VOD_ADDRESS_EN = 'http://yyk5.gxzyy.com.cn/video/48cab640814b42528a7500289e8fa46f-00749c680981dcbde4619b7a7c7b0229-ld.mp4'
  new Vue({
    el: '#app',
    store,
    render: h => h(App)
  }).$mount('#app')
} else {
  if (!store.state.CODE) {
    alert('本视频仅支持关注公众号后观看')
    // eslint-disable-next-line no-undef,no-unused-vars
    WeixinJSBridge.call('closeWindow')
  }
  store.dispatch('getData', { status: 'init', code: store.state.CODE, state: store.state.STATE_CODE, video: 'wqx' }).then(res => {
    if (res.code === 200) {
      store.state.VOD_ADDRESS = res.data.vod
      store.state.VOD_ADDRESS_EN = res.data.vod_en
      store.state.VOD_COVER = res.data.cover
      store.state.VOD_NANE = res.data.name
      new Vue({
        el: '#app',
        store,
        render: h => h(App)
      }).$mount('#app')
    } else if (res.code > 0) {
      alert(res.message)
    } else {
      alert('请求错误')
    }
  }).catch(() => {
    alert('本视频仅支持关注公众号后观看')
  })
}

function GetQueryString (name) {
  const url = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const newUrl = window.location.search.substr(1).match(url)
  if (newUrl != null) {
    return unescape(newUrl[2])
  } else {
    return false
  }
}
